import { Mediator, payload } from "modular-openscriptjs";
import { approved, eParse, inform } from "../helpers";
import { api, STRINGS } from "../declarations";
import { $e } from "../ojs.events";

export default class DealMediator extends Mediator {
  $$deal = {
    needs: {
      deletion: (ed, event) => this.deleteDeal(ed, event),
      productRemoval: (ed, event) => this.removeProductFromDeal(ed, event),
    },
  };

  async deleteDeal(ed, event) {
    if (!approved(event, ed, "Are you sure you want to delete this deal?"))
      return;

    const { message } = eParse(ed);

    const res = await api.delete(
      `companies/${message.businessId}/deals/${message.id}`,
    );

    if (!res) {
      inform("Failed to delete deal", STRINGS.ERROR);
      return this.send($e.deal.has.deletionError, ed);
    }

    inform("Deal deleted successfully", STRINGS.SUCCESS);
    this.send($e.deal.deleted, payload({ id: message.id }));
  }

  // A business detaching one of its own products from a deal (business-owned
  // or global) - the deal itself is untouched, see ProductController::removeFromDeal.
  async removeProductFromDeal(ed, event) {
    if (
      !approved(
        event,
        ed,
        "Remove this product from the deal? Customers will stop seeing this discount on it.",
      )
    )
      return;

    const { message } = eParse(ed);

    const res = await api.delete(
      `companies/${message.businessId}/products/${message.productId}/deals/${message.dealId}`,
    );

    if (!res) {
      inform("Failed to remove product from deal", STRINGS.ERROR);
      return this.send($e.deal.has.productRemovalError, ed);
    }

    inform("Product removed from deal", STRINGS.SUCCESS);
    this.send(
      $e.deal.productRemoved,
      payload({ dealId: message.dealId, productId: message.productId }),
    );
  }
}
